import { useEffect } from 'react'
import { PaymentMethodType } from '../../model'
import { PCL_CARD_EXPIRY_LIMIT_IN_MONTHS } from '../../utils/credit-card'
import { useAppDispatch } from '../hooks'
import { useCheckoutState, usePreferredCard } from '../checkout/hooks'
import { setCardsForExpiryLimit } from '../checkout/reducer'
import { useHasUserInitiatedChangedPaymentMethod, useSelectedPaymentMethod } from '../topaz/hooks'
import { selectPaymentMethod } from '../topaz/reducer'

export const useEnforcePclCardExpiryLimit = (): void => {
  const dispatch = useAppDispatch()
  const { error } = useCheckoutState()
  const { card } = usePreferredCard() ?? {}
  const selectedPaymentMethod = useSelectedPaymentMethod()
  const userInitiatedChangedPaymentMethod = useHasUserInitiatedChangedPaymentMethod()

  useEffect(() => {
    if (error == null && !userInitiatedChangedPaymentMethod) {
      dispatch(setCardsForExpiryLimit(PCL_CARD_EXPIRY_LIMIT_IN_MONTHS))
    }
  }, [error])

  useEffect(() => {
    if (!userInitiatedChangedPaymentMethod && card != null && card?.error === null && selectedPaymentMethod?.type === PaymentMethodType.CREDIT_CARD) {
      dispatch(
        selectPaymentMethod({
          card: {
            token: card.token,
          },
          type: PaymentMethodType.CREDIT_CARD,
        })
      )
    }
  }, [card])
}
